import { createRequest, RequestConfig } from 'app/common/api';

import { TReportConstraints } from '../core/report-constraints';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/get_report_templates',
};

export const getReportsRequest = (constraints?: TReportConstraints) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(constraints),
  });
